'use strict';
angular.module('replyReportV2Module', []).
controller('replyReportCtrlV2', function($scope, $modalInstance, trsspliceString, Upload, commandService, report, replycontent) {
    var ue;
    $scope.report = report;
    $scope.typeArr=['普通', '重要', '紧急', '敏感'];
    $scope.submit = function() {
        $modalInstance.close({ content: ue.getContent() });
    };
    $scope.close = function() {
        $modalInstance.dismiss();
    };
    LazyLoad.js(["./lib/ueditor2/ueditor.config.js?v=6.0", "./lib/ueditor2/ueditor.all.js?v=6.0"], function() {
        ue = UE.getEditor('replyEditer', {
            toolbars: [
                [
                    'source' /*0*/ ,
                    'undo' /*1*/ ,
                    'redo' /*2*/ ,
                    '|' /*3*/ ,
                    'cut' /*4*/ ,
                    'copy' /*5*/ ,
                    'paste' /*6*/ ,
                    '|' /*7*/ ,
                    'customstyle' /*8*/ ,
                    'fontfamily' /*9*/ ,
                    'fontsize' /*10*/ ,
                    'forecolor' /*11*/ ,
                    'bold' /*12*/ ,
                    'italic' /*13*/ ,
                    'underline' /*14*/ ,
                    'strikethrough' /*15*/ ,
                    'subscript' /*16*/ ,
                    'backcolor' /*17*/ ,
                    '|' /*18*/ ,
                    'justifyleft' /*19*/ ,
                    'justifycenter' /*20*/ ,
                    'justifyright' /*21*/ ,
                    'justifyjustify' /*22*/ ,
                    '|' /*23*/ ,
                    'insertorderedlist' /*24*/ ,
                    'insertunorderedlist' /*25*/ ,
                    'directionalityltr' /*26*/ ,
                    'directionalityrtl' /*27*/ ,
                    'lineheight' /*28*/ ,
                    /* 'background', 'backgroundimg', */
                    '|' /*29*/ ,
                    'formatmatch' /*30*/ ,
                    'searchreplace' /*31*/ ,
                    'insertframe' /*32*/ ,
                    'insertimage' /*33*/ , /*'insertvideo' ,*/
                    'link' /*34*/ ,
                    'unlink' /*35*/ ,
                    'inserttable' /*36*/ ,
                    'insertrow' /*37*/ ,
                    'insertcol' /*38*/ ,
                    'inserttitle' /*39*/ ,
                    'insertparagraphbeforetable' /*40*/ ,
                    'fullscreen' /*41*/ ,
                    'removeformat' /*42*/ ,
                    'autotypeset' /*43*/ ,
                    'indent' /*44*/ ,
                    'pasteplain' /*45*/
                ]
            ],
            zIndex: 2000,
            pasteplain:true,
            initialFrameHeight: 100
        });
        ue.ready(function() {
            ue.setContent(replycontent);
        });
    });
})
